export default __webpack_public_path__ + "static/media/Wood-And-Welds-Logo-Vertical.552d5ccd.svg";